import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/smallRoutine';
const smallRoutine: Array<RouteConfig> = [
    {
        path: 'basic-info/small-routine',
        name: 'smallRoutine',
        redirect: { name: 'superior' },
        meta: {
            menuMatch: 'smallRoutine',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'superior',
                name: 'superior',
                component: () => import(`@/${BASE_PATH}/Superior.vue`),
                meta: {
                    index: '8-1',
                },
            },
            {
                path: 'customer',
                name: 'customer',
                component: () => import(`@/${BASE_PATH}/Customer.vue`),
                meta: {
                    index: '8-2',
                },
            },
            {
                path: 'spread',
                name: 'spread',
                component: () => import(`@/${BASE_PATH}/Spread.vue`),
                meta: {
                    index: '8-3',
                },
            },
            {
                path: 'spread-detail',
                name: 'spreadDetail',
                component: () => import(`@/${BASE_PATH}/SpreadDetail.vue`),
                meta: {
                    index: '8-3',
                },
            },
            {
                path: 'scan',
                name: 'scan',
                component: () => import(`@/${BASE_PATH}/Scan.vue`),
                meta: {
                    index: '8-4',
                },
            },
        ],
    },
];
export default smallRoutine;